import React from "react";
import { Route, IndexRoute } from "react-router";

import App from "./containers/App";
import Startseite from "./containers/Startseite";
import Impressum from "./containers/Impressum";
import Datenschutz from "./containers/Datenschutz";
import Ausbildung_Fachangestellte from "./containers/Ausbildung_Fachangestellte";
import Medizinische_Fachangestellte from "./containers/Medizinische_Fachangestellte";

export default process.env.BROWSER ? (
    <Route path="/" component={App}>
        <IndexRoute
            onEnter={() => window.scrollTo(0, 0)}
            component={Startseite}
        />
        <Route
            onEnter={() => window.scrollTo(0, 0)}
            path="/impressum"
            component={Impressum}
        />
        <Route
            onEnter={() => window.scrollTo(0, 0)}
            path="/datenschutz"
            component={Datenschutz}
        />
        <Route
            onEnter={() => window.scrollTo(0, 0)}
            path="/ausbildung-medizinische-fachangestellte"
            component={Ausbildung_Fachangestellte}
        />
        <Route
            onEnter={() => window.scrollTo(0, 0)}
            path="/medizinische-fachangestellte"
            component={Medizinische_Fachangestellte}
        />
    </Route>
) : (
    <Route path="/" component={App}>
        <IndexRoute component={Startseite} />
        <Route path="/impressum" component={Impressum} />
        <Route path="/datenschutz" component={Impressum} />
        <Route path="/datenschutz" component={Datenschutz} />
        <Route
            path="/ausbildung-medizinische-fachangestellte"
            component={Ausbildung_Fachangestellte}
        />
        <Route
            path="/medizinische-fachangestellte"
            component={Medizinische_Fachangestellte}
        />
    </Route>
);



// WEBPACK FOOTER //
// ./src/js/routes.js